import React, { useEffect, useState } from 'react'
import { getCashFlowStatement } from '../../utils/ActionCreator';
import CashflowStatementTable from './CashflowStatementTable';
import SpinnerLoader from '../../../../../../../presentationals/Loader/Loader.component';
import moment from 'moment';
// import SpinnerLoader from '../../../../../Common/Loader.component';

function CashflowStatement() {

    const [isLoad,setIsLoad] = useState(false);
    const [allData,setAllData] = useState([]);

    const fetchCombineStats=()=>{
        setIsLoad(true);
        getCashFlowStatement((callback)=>{
            setIsLoad(false);
            if(callback.message === "success"){
                setAllData(callback.data);
            }
        },(onErr)=>{
            setIsLoad(false);

        });
    }


    useEffect(()=>{
        fetchCombineStats();
    },[])

    const hasRealData = allData && allData.length > 0;

    const generateMockCashflowMonthlyData = () => {
      const months = [];
      const startOfYear = moment().startOf("year");
      for (let i = 0; i < 12; i++) {
        const m = startOfYear.clone().add(i, "months").format("YYYY-MM-DD");
        months.push({
          currentMonth: m,
          cashAtBeginning: 500000 + i * 25000,
          cashInflow: 120000 + (i % 3) * 15000,
          processingFees: 5000,
          interest: 15000,
          firstTranche: 40000,
          secondTranche: 35000,
          thirdTranche: 20000,
          penaltyLateFees: 5000,
          cashOutflow: 85000 + (i % 2) * 10000,
          technologyExpense: 15000,
          thirdPartApi: 5000,
          administrativeExpense: 8000,
          employeeSalary: 40000,
          customerAcquisition: 12000,
          interestPaid: 2000,
          regulatoryCompliance: 1000,
          provisioning: 2000,
          netCashflow: 35000 + (i % 3) * 15000 - (i % 2) * 10000
        });
      }
      return months;
    };

    const mockDataToShow = hasRealData ? allData : [
      {
        productName: "Personal Loan",
        monthlyData: generateMockCashflowMonthlyData()
      },
      {
        productName: "Business Loan",
        monthlyData: generateMockCashflowMonthlyData()
      }
    ];

  return (
    <>
    {isLoad && <SpinnerLoader />}
    {mockDataToShow.map((item, index)=>{
        return (
            <React.Fragment key={index}>
                <CashflowStatementTable item ={item?.monthlyData} productName={item?.productName} />
            </React.Fragment>
        )
    })}
    </>
  )
}

export default CashflowStatement